import React, { Component } from 'react';
import Styles from './App.module.scss';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
import { HISTORY } from './helper/HistoryHelper';
import Loading from './view/loading/Loading';
import ChatRouter from './view/chat/ChatRouter';
import CloseRouter from './view/close/CloseRouter';
import RatingRouter from './view/rating/RatingRouter';
import TestView from './view/TestView';
import Maintenance from './view/maintenance/Maintenance';
import ExpiredRouter from './view/expire/ExpiredRouter';
import EntryRouter from './view/EntryRouter';
import InitView2 from './view/InitView2';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

@observer
class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`d-flex flex-default ${Styles.Content}`}>
        <Router history={HISTORY}>
          <Switch>
            <Route path="/init" component={EntryRouter} />
            <Route path="/init2" component={InitView2} />
            <Route path="/test" component={TestView} />
            <Route path="/loading/:fromLanding?" component={Loading} />
            <Route path="/chat/:channelId" component={ChatRouter} />
            <Route path="/close" component={CloseRouter} />
            <Route path="/rating/:channelId" component={RatingRouter} />
            <Route path="/maintenance" component={Maintenance} />
            <Redirect
              exact
              from="/"
              to={{
                pathname: '/loading',
                search: '',
              }}
              push={false}
            />
            <Route component={ExpiredRouter} />
          </Switch>
        </Router>
        <NotificationContainer />
      </div>
    );
  }
}

export default App;
